import type { FC } from 'react';
import {
  documentTypeLabels,
  documentTypeOptions,
} from 'src/apis/document-exchange/mappings';
import type { OperatorDocumentsInboxRequest } from 'src/apis/document-exchange/use-operator-documents-inbox';
import type { OperatorDocumentsOutboxRequest } from 'src/apis/document-exchange/use-operator-documents-outbox';
import { FilterCard } from 'src/components/data-display/expandable-filters';
import { DateRangePicker } from 'src/components/form/datepicker/date-range-picker';
import { Input } from 'src/components/form/input';
import { MultiSelect } from 'src/components/form/select/multi-select';
import type { PageParams } from 'src/pages/shippers/documents/use-page-params';
import {
  documentStatusLabels,
  documentStatusOptions,
} from 'src/pages/shippers/documents/utils';

type FilterCardProps = {
  type: 'INBOX' | 'OUTBOX';
  pageParams: PageParams;
  documents: OperatorDocumentsOutboxRequest | OperatorDocumentsInboxRequest;
};

export const DocumentsFilterCard: FC<FilterCardProps> = ({
  type,
  pageParams,
}) => {
  return (
    <FilterCard
      constraintViolation={null}
      pageParams={pageParams}
      filters={{
        changedAtStart: {
          type: 'date-time',
          end: 'changedAtEnd',
          field: (
            <DateRangePicker
              groupLabel={pageParams.filter.changedAtStart.label}
              fromName="changedAtStart"
              fromLabel="Time of Modification (from)"
              toName="changedAtEnd"
              toLabel="Time of Modification (until)"
              time
            />
          ),
        },
        documentName: {
          type: 'value',
          field: (
            <Input
              name="documentName"
              label={pageParams.filter.documentName.label}
              placeholder="Document Name"
            />
          ),
        },
        documentDescription: {
          type: 'value',
          field: (
            <Input
              name="documentDescription"
              label={pageParams.filter.documentDescription.label}
              placeholder="Document's Description"
            />
          ),
        },
        documentType: {
          type: 'list',
          mappedValue: pageParams.value.documentType.map(
            (type) => documentTypeLabels[type]
          ),
          field: (
            <MultiSelect
              name="documentType"
              label={pageParams.filter.documentType.label}
              options={documentTypeOptions}
              placeholder="E.g. Business Communication"
            />
          ),
        },
        documentStatus: {
          type: 'list',
          mappedValue: pageParams.value.documentStatus.map(
            (status) => documentStatusLabels[status]
          ),
          field: type === 'OUTBOX' && (
            <MultiSelect
              name="documentStatus"
              label={pageParams.filter.documentStatus.label}
              options={documentStatusOptions}
              placeholder="E.g. Published"
            />
          ),
        },
      }}
    />
  );
};
